import React from "react";
import { Badge, Box, Flex, Grid } from "@chakra-ui/react";
import { Link as GatsbyLink, withPrefix } from "gatsby";

const NavLink: React.FC<{
  isNew?: boolean;
  uri: string;
  to: string;
}> = ({ to, uri, children, isNew }) => {
  const isActive = withPrefix(to) === uri.replace(/\/$/, "");
  return (
    <Grid
      templateColumns="repeat(2, auto)"
      fontSize="lg"
      fontWeight="semibold"
      as={GatsbyLink}
      to={to}
      color={!isActive ? "inactive" : undefined}
    >
      {children}
      <Flex align="center">
        {isNew && (
          <Badge ml="2" colorScheme="green">
            New
          </Badge>
        )}
      </Flex>
      <Box
        h="1"
        mt="2"
        roundedTop="full"
        bgColor={isActive ? "primary" : undefined}
      />
    </Grid>
  );
};

export default NavLink;
